import { z } from 'zod';

export const blogPostSchema = z.object({
  id: z.string().uuid(),
  site_id: z.string().uuid(),
  title: z.string().min(1),
  slug: z.string().min(1),
  excerpt: z.string().optional(),
  content: z.string(),
  featured_image: z.string().uuid().nullable(),
  author_id: z.string().uuid(),
  category_id: z.string().uuid().nullable(),
  tags: z.array(z.string()).default([]),
  is_published: z.boolean().default(false),
  published_at: z.string().datetime().nullable(),
  meta_title: z.string().optional(),
  meta_description: z.string().optional(),
  created_at: z.string().datetime(),
  updated_at: z.string().datetime(),
});

export type BlogPost = z.infer<typeof blogPostSchema>;

export const blogCategorySchema = z.object({
  id: z.string().uuid(),
  site_id: z.string().uuid(),
  name: z.string().min(1),
  slug: z.string().min(1),
  description: z.string().optional(),
  created_at: z.string().datetime(),
  updated_at: z.string().datetime(),
});

export type BlogCategory = z.infer<typeof blogCategorySchema>;
